module.exports = __webpack_public_path__ + "img/md.667635e5.svg";